import { createSlice } from '@reduxjs/toolkit'

export const salesTargetInitialState = {
  formData: {
    activeDisplay: true,
  },
  displayContent: {
    en: {
      newDisplayTitle: '',
      parentCategory: '',
      childCategory: '',
      exerpt: '',
      terms: '',
    }
  },
  displayContentMedia: {
    title: '',
    imageId: '',
    imageUri: '',
    imageBase64: '',
    optIn: false
  }
}

const salesTargetSlice = createSlice({
  name: 'salesTarget',
  initialState: salesTargetInitialState,
  reducers: {
    setSalesTargetDisplayContent: (state, action) => {
      return {
        ...state,
        displayContent: action.payload,
      }
    },
    resetSalesTarget: () => salesTargetInitialState,
    setSalesTargetDisplayContentMedia: (state, action) => {
      return {
        ...state,
        displayContentMedia: action.payload,
      }
    },
    resetSalesTargetDisplayContentMedia: state => {
      return {
        ...state,
        displayContentMedia: {
          title: '',
          imageId: '',
          imageUri: '',
          imageBase64: '',
        },
      }
    },
    setSalesTargetFormData: (state, action) => {
      return {
        ...state,
        formData: action.payload,
      }
    },
  },
})

export const {
  setSalesTargetDisplayContent,
  setSalesTargetDisplayContentMedia,
  resetSalesTargetDisplayContentMedia,
  resetSalesTarget,
  setSalesTargetFormData
} = salesTargetSlice.actions

export const salesTargetSliceReducer = salesTargetSlice.reducer
